/* Global styles */
export const iconStyle = "h-5 w-5";
